export default class CreateDatabaseResult {

    Accepted: boolean;
    Status: number;
    ErrorMessage: string;

    constructor(accepted: boolean, status: number, errorMessage: string) {
        this.Accepted = accepted;
        this.Status = status;
        this.ErrorMessage = errorMessage;
    }
}
